import * as React from 'react';
import {StyleSheet, Text, View} from 'react-native';
import {
  BottomSheetModal,
  BottomSheetModalProvider,
  BottomSheetBackdrop,
} from '@gorhom/bottom-sheet';
import {SafeAreaInsetsContext} from 'react-native-safe-area-context';
import {normalize} from '../../utils/helpers';

class BottomSheet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
    this.bottomSheetModalRef = React.createRef();
  }

  open() {
    this.bottomSheetModalRef?.current?.present();
  }

  snapToIndex(index) {
    this.bottomSheetModalRef?.current?.snapToIndex(index);
  }

  close() {
    this.bottomSheetModalRef?.current?.dismiss();
  }

  onBackdropClick = () => {
    if (this.props?.onBackdropClick && this.props.backdropBehaviour === 1) {
      this.props.onBackdropClick();
    }
  };

  renderBackdrop = props => {
    return (
      <BottomSheetBackdrop
        {...props}
        //pressBehavior={this.props.backdropBehaviour}
        onPress={this.onBackdropClick}>
        {this.props.renderBackdrop ? (
          this.props.renderBackdrop(props)
        ) : (
          <View />
        )}
      </BottomSheetBackdrop>
    );
  };

  onCloseCallback = () => {
    if (this.props?.onCloseCallback) {
      this.props.onCloseCallback();
    }
  };
  onChange = index => {
    if (index == 0) {
      this.close();
    }
  };

  renderModule = insets => {
    let snapPoints = this.props.snapPoints;
    let bottomInsetRequired = this.props.bottomInsetRequired;
    return (
      <BottomSheetModal
        ref={this.bottomSheetModalRef}
        backdropComponent={this.renderBackdrop}
        snapPoints={snapPoints}
        index={1}
        onChange={this.onChange}
        bottomInset={bottomInsetRequired ? insets?.bottom : 0}
        // bottomInset={0}
        detached={false}
        keyboardBehavior="extend"
        keyboardBlurBehavior="none"
        onDismiss={this.onCloseCallback}
        {...this.props.extraProps}>
        {this.props.children}
      </BottomSheetModal>
    );
  };

  render() {
    const {isLoading = false} = this.state;

    if (isLoading) {
      return (
        <View style={styles.loading}>
          <Text>{'Loading Properties...'}</Text>
        </View>
      );
    }

    return (
      <SafeAreaInsetsContext.Consumer>
        {insets =>
          !this.props.isModuleProviderRequired ? (
            this.renderModule(insets)
          ) : (
            <BottomSheetModalProvider>
              {this.renderModule(insets)}
            </BottomSheetModalProvider>
          )
        }
      </SafeAreaInsetsContext.Consumer>
    );
  }
}

export default BottomSheet;

BottomSheet.defaultProps = {
  snapPoints: ['2%', '92%'],
  containerStyle: {},
  renderComponent: () => {},
  renderBackdrop: () => {},
  bottomInset: 0,
  bottomInsetRequired: true,
  detached: false,
  keyboardBehavior: 'interactive',
  keyboardBlurBehavior: 'restore',
  onOpen: () => {},
  onClose: () => {},
  extraProps: {},
  snapToIndex: () => {},
  isModuleProviderRequired: true,
  onCloseCallback: () => {},
  backdropBehaviour: 'close',
  onBackdropClick: () => {},
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  loading: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  header: {
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: 20,
    textAlign: 'center',
    marginHorizontal: 20,
  },
});
